
// import React from 'react';
// import './ReviewsSection.css';
// import { useGym } from '../context/GymContext';
// import { motion } from 'framer-motion';

// function Stars({ count }) {
//   return (
//     <div className="stars">
//       {[1, 2, 3, 4, 5].map((i) => (
//         <svg
//           key={i}
//           className={'star' + (i <= count ? ' star--filled' : '')}
//           viewBox="0 0 20 20"
//           width="16"
//           height="16"
//         >
//           <path d="M10 1l2.4 7.3H20l-6.2 4.5 2.4 7.3L10 15.5l-6.2 4.6 2.4-7.3L0 8.3h7.6z" />
//         </svg>
//       ))}
//     </div>
//   );
// }

// export default function ReviewsSection() {
//   const { data } = useGym();
//   const { reviews, gym } = data;

//   // 🔥 TEXT animation (same pattern everywhere now)
//   const fadeUp = {
//     hidden: { opacity: 0, y: 30 },
//     show: { opacity: 1, y: 0 }
//   };

//   // 🔥 Stagger for cards
//   const container = {
//     hidden: {},
//     show: {
//       transition: {
//         staggerChildren: 0.15,
//       },
//     },
//   };

//   const item = {
//     hidden: { opacity: 0, y: 40 },
//     show: { opacity: 1, y: 0 },
//   };

//   return (
//     <section id="reviews" className="reviews-section">
//       <div className="container">

//         {/* 🔥 HEADER (NOW STEP-BY-STEP) */}
//         <motion.p
//           className="section-label"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: false, amount: 0.2 }}
//           transition={{ duration: 0.5 }}
//         >
//           What Members Say
//         </motion.p>

//         <motion.h2
//           className="section-title"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: false, amount: 0.2 }}
//           transition={{ duration: 0.5, delay: 0.1 }}
//         >
//           Google <span>Reviews</span>
//         </motion.h2>

//         <motion.div
//           className="divider"
//           variants={fadeUp}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: false, amount: 0.2 }}
//           transition={{ duration: 0.5, delay: 0.2 }}
//         />

//         {/* 🔥 SUMMARY */}
//         <motion.div
//           className="reviews-summary"
//           initial={{ opacity: 0, y: 30 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           viewport={{ once: false, amount: 0.2 }}
//           transition={{ duration: 0.5, delay: 0.3 }}
//         >
//           <div className="reviews-score">
//             <span className="reviews-score-num">{gym.googleRating}</span>
//             <Stars count={5} />
//             <span className="reviews-score-label">
//               Based on Google Reviews
//             </span>
//           </div>

//           <motion.a
//             href={gym.googleReviewUrl}
//             target="_blank"
//             rel="noreferrer"
//             className="reviews-cta"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//           >
//             Write a Review on Google
//           </motion.a>
//         </motion.div>

//         {/* 🔥 REVIEWS GRID */}
//         <motion.div
//           className="reviews-grid"
//           variants={container}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: false, amount: 0.2 }}
//         >
//           {reviews.map((review, i) => (
//             <motion.div
//               key={i}
//               className="review-card"
//               variants={item}
//               whileHover={{ y: -8, scale: 1.02 }}
//               transition={{ type: 'spring', stiffness: 200 }}
//             >
//               <div className="review-card__top">
//                 <div className="review-card__avatar">
//                   {review.avatar}
//                 </div>

//                 <div>
//                   <p className="review-card__name">{review.name}</p>
//                   <Stars count={review.rating} />
//                 </div>

//                 <span className="review-card__date">
//                   {review.date}
//                 </span>
//               </div>

//               <p className="review-card__text">
//                 "{review.text}"
//               </p>

//               <div className="review-card__google">
//                 <svg viewBox="0 0 24 24" width="14" height="14">
//                   <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
//                   <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
//                   <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
//                   <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
//                 </svg>
//                 <span>Google Review</span>
//               </div>

//             </motion.div>
//           ))}
//         </motion.div>

//       </div>
//     </section>
//   );
// }


import React from 'react';
import './ReviewsSection.css';
import { useGym } from '../context/GymContext';
import { motion } from 'framer-motion';

function Stars({ count }) {
  return (
    <div className="stars">
      {[1, 2, 3, 4, 5].map((i) => (
        <svg
          key={i}
          className={'star' + (i <= count ? ' star--filled' : '')}
          viewBox="0 0 20 20"
          width="16"
          height="16"
        >
          <path d="M10 1l2.4 7.3H20l-6.2 4.5 2.4 7.3L10 15.5l-6.2 4.6 2.4-7.3L0 8.3h7.6z" />
        </svg>
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  const { data } = useGym();
  const { reviews, gym } = data;

  const fadeUp = {
    hidden: { opacity: 0, y: 30 },
    show: { opacity: 1, y: 0 }
  };

  const container = {
    hidden: {},
    show: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const item = {
    hidden: { opacity: 0, y: 40 },
    show: { opacity: 1, y: 0 },
  };

  return (
    <section id="reviews" className="reviews-section">
      <div className="container">

        {/* HEADER */}
        <motion.p
          className="section-label"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.5 }}
        >
          What Members Say
        </motion.p>

        <motion.h2
          className="section-title"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          Google <span>Reviews</span>
        </motion.h2>

        <motion.div
          className="divider"
          variants={fadeUp}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        />

        {/* SUMMARY */}
        <motion.div
          className="reviews-summary"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.2 }}
          transition={{ duration: 0.5, delay: 0.3 }}
        >
          <div className="reviews-score">
            <span className="reviews-score-num">{gym.googleRating}</span>
            <Stars count={5} />
            <span className="reviews-score-label">
              Based on Google Reviews
            </span>
          </div>

          <motion.a
            href={gym.googleReviewUrl}
            target="_blank"
            rel="noreferrer"
            className="reviews-cta"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Write a Review on Google
          </motion.a>
        </motion.div>

        {/* REVIEWS GRID */}
        <motion.div
          className="reviews-grid"
          variants={container}
          initial="hidden"
          whileInView="show"
          viewport={{ once: false, amount: 0.2 }}
        >
          {reviews.map((review, i) => (
            
            <motion.a
              key={i}
              href={review.link}
              target="_blank"
              rel="noreferrer"
              className="review-card"
              variants={item}
              whileHover={{ y: -8, scale: 1.02 }}
              transition={{ type: 'spring', stiffness: 200 }}
            >

              <div className="review-card__top">
                <div className="review-card__avatar">
                  {review.avatar}
                </div>

                <div>
                  <p className="review-card__name">{review.name}</p>
                  <Stars count={review.rating} />
                </div>

                <span className="review-card__date">
                  {review.date}
                </span>
              </div>

              <p className="review-card__text">
                "{review.text}"
              </p>

              <div className="review-card__google">
                <svg viewBox="0 0 24 24" width="14" height="14">
                  <path fill="#4285f4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                  <path fill="#34a853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                  <path fill="#fbbc05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                  <path fill="#ea4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                </svg>
                <span>Google Review</span>
              </div>

            </motion.a>

          ))}
        </motion.div>

      </div>
    </section>
  );
}